import { useEffect } from 'react';
import { OrganisationDetailsResponse } from 'src/apis/organisation-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useOrganisationDetails({ url }: { url: string }) {
  const organisationServicePublic = useAxios(
    (axios, signal, url) =>
      axios.request<OrganisationDetailsResponse>({
        signal,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    organisationServicePublic.execute(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return organisationServicePublic;
}

export type OrganisationDetailsRequest = ReturnType<
  typeof useOrganisationDetails
>;
